export function handleLinkedContainers() {
  document.querySelectorAll('.js-linked-container').forEach(container =>
    container.addEventListener('click', () => location.assign(container.dataset.href)))
}
